import React from "react";
import PoslovniProcesiOwnerItem from "../poslovniProcesiOwnerItem";

export default function PoslovniProcessOwnerTable({
  employees,
  preparedBy,
  controlledBy,
  approvedBy,
  preparedAt,
  controlledAt,
  approvedAt,
  onChangePreparedBy,
  onChangeControlledBy,
  onChangeApprovedBy,
  onChangePreparedAt,
  onChangeControlledAt,
  onChangeApprovedAt,
  disabled,
}) {
  const poslovniProcessTableTitles = [
    { id: 1, title: "", width: "25%" },
    { id: 2, title: "PRIPREMA", width: "25%" },
    { id: 3, title: "KONTROLIŠE", width: "25%" },
    { id: 4, title: "ODOBRAVA", width: "25%" },
  ];

  return (
    <div className="table" style={{ marginTop: "0" }}>
      <ul className="table-header">
        {poslovniProcessTableTitles.map((title) => {
          return (
            <li
              className="table-header-item"
              key={title.id}
              style={{ width: title.width }}
            >
              <p className="table-header-title">{title.title}</p>
            </li>
          );
        })}
      </ul>
      <div className="poslovli-proseci-table-list">
        <PoslovniProcesiOwnerItem
          title="ime i prezime"
          type="employee"
          employees={employees}
          preparedValue={preparedBy}
          controlledValue={controlledBy}
          approvedValue={approvedBy}
          onChangePrepared={onChangePreparedBy}
          onChangeControlled={onChangeControlledBy}
          onChangeApproved={onChangeApprovedBy}
          disabled={disabled}
        />
        <PoslovniProcesiOwnerItem title="potpis" type="static" />
        <PoslovniProcesiOwnerItem
          title="datum"
          type="date"
          preparedValue={preparedAt}
          controlledValue={controlledAt}
          approvedValue={approvedAt}
          onChangePrepared={onChangePreparedAt}
          onChangeControlled={onChangeControlledAt}
          onChangeApproved={onChangeApprovedAt}
          disabled={disabled}
        />
      </div>
    </div>
  );
}
